import { httpClient } from "@coworker/http-client";
import { Comment, CreateComment } from "../types/Comment";

export async function createComment(createComment: CreateComment) {
  return httpClient.tasks.post<Comment>("/comments", { body: createComment });
}

export async function updateComment(
  commentId: string,
  updates: Partial<Pick<CreateComment, "text" | "images">>
) {
  return httpClient.tasks.put<Comment>(`/comments/${commentId}`, {
    body: updates,
  });
}

export async function deleteComment(commentId: string) {
  await httpClient.tasks.delete(`/comments/${commentId}`);
}
